import NavigationUtils from '../../js/utils/NavigationUtils';

$(document).ready(function ($) {
	Site.run();

	$('button[type="submit"]').on('click', function (e) {
		// TODO: temporaneo per non fare diversi file javascript. Cambiare
		if ($('#inputNewPassword').length) {
			const $confirm = $('#inputPasswordConfirm');
			if ($('#inputNewPassword').val() !== $confirm.val()) {
				$confirm.siblings('.err-container').text('Le due password non coincidono');
				return false;
			} else {
				$confirm.siblings('.err-container').text('');
				if (!passValidator()) return false;
			}
		}

		return true;
	});

	$('form').on('submit', function () {
		NavigationUtils.LoaderShow();
	});

	$('#inputNewPassword').keyup(function (e) {
		passValidator(e.currentTarget);
	});

	const pswValidator = {
		pswInput: $('.js-form-password'),
		pswInputMatch: $('.js-form-password-match'),
		submitBtn: $('.js-form-submit'),
		elementListners: function (inputElement) {
			inputElement
				.on('keyup', function (e) {
					passValidator(e.currentTarget);
					pswValidator.submitBtn.attr('disabled', !passValidator(e.currentTarget));
				})
				.on('focus', function () {
					$('#pswd_info').show();
				})
				.on('blur', function () {
					$('#pswd_info').hide();
				});
		},
		passedRules: {
			length: false,
			letter: false,
			capital: false,
			number: false,
			match: false,
			space: false,
		},
		allRulesPassed: function () {
			return Object.values(pswValidator.passedRules).every((rule) => rule === true);
		},
	};

	pswValidator.elementListners(pswValidator.pswInput);
	pswValidator.elementListners(pswValidator.pswInputMatch);

	let passValidator = function (target) {
		var pswd = pswValidator.pswInput.val();
		var pswdMatch = pswValidator.pswInputMatch.val();
		var target = $(target);

		let valid = false;

		if (pswd.length < 8) {
			$('#length').removeClass('valid').addClass('invalid');
			target.focus();
			pswValidator.passedRules.length = false;
		} else {
			$('#length').removeClass('invalid').addClass('valid');
			pswValidator.passedRules.length = true;
		}

		//validate letter
		if (pswd.match(/[A-z]/)) {
			$('#letter').removeClass('invalid').addClass('valid');
			pswValidator.passedRules.letter = true;
		} else {
			$('#letter').removeClass('valid').addClass('invalid');
			target.focus();
			pswValidator.passedRules.letter = false;
		}

		//validate capital letter
		if (pswd.match(/[A-Z]/)) {
			$('#capital').removeClass('invalid').addClass('valid');
			pswValidator.passedRules.capital = true;
		} else {
			$('#capital').removeClass('valid').addClass('invalid');
			target.focus();
			pswValidator.passedRules.capital = false;
		}

		//validate number
		if (pswd.match(/\d/)) {
			$('#number').removeClass('invalid').addClass('valid');
			pswValidator.passedRules.number = true;
		} else {
			$('#number').removeClass('valid').addClass('invalid');
			target.focus();
			pswValidator.passedRules.number = false;
		}
		if (pswdMatch === pswd && pswd.length > 0) {
			$('#match').removeClass('invalid').addClass('valid');
			pswValidator.passedRules.match = true;
		} else {
			$('#match').removeClass('valid').addClass('invalid');
			target.focus();
			pswValidator.passedRules.match = false;
		}
		
		//validate space
		if (pswd.match(/[^a-zA-Z0-9\-\/]/)) {
			$('#space').removeClass('invalid').addClass('valid');
			pswValidator.passedRules.space = true;
		} else {
			$('#space').removeClass('valid').addClass('invalid');
			target.focus();
			pswValidator.passedRules.space = false;
		}

		const allPassed = pswValidator.allRulesPassed();
		if (!allPassed) {
			NavigationUtils.LoaderHide();
		}

		return allPassed;
	};
});
